import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardMedia,
  CardActionArea,
  Typography,
  Box,
} from "@mui/material";
import { styled } from "@mui/system";
import { motion } from "framer-motion";


// Import all images
import Ino1 from "../images/Ino1.jpeg";
import Ino2 from "../images/Ino2.jpeg";
import Ino3 from "../images/Ino3.jpeg";
import Ino4 from "../images/Ino4.jpeg";
import Ino5 from "../images/Ino5.jpeg";
import Ino6 from "../images/Ino6.jpeg";
import Ino7 from "../images/Ino7.jpeg";
import Ino8 from "../images/Ino8.jpeg";
import Ino9 from "../images/Ino9.jpeg";
import Ino10 from "../images/Ino10.jpeg";
import Ino11 from "../images/Ino11.jpeg";
import Ino12 from "../images/Ino12.jpeg";
import Ino13 from "../images/Ino13.jpeg";
import Ino14 from "../images/Ino14.jpeg";
import Ino15 from "../images/Ino15.jpg";
import Ino16 from "../images/Ino16.jpeg";
import Ino17 from "../images/Ino17.jpeg";
import Ino18 from "../images/Ino18.jpeg";
import Ino19 from "../images/Ino19.jpeg";
import Ino20 from "../images/Ino20.jpeg";
import Ino21 from "../images/Ino21.jpeg";
import Ino22 from "../images/Ino22.jpeg";
import Ino23 from "../images/Ino23.jpeg";
import Ino24 from "../images/Ino24.jpg";
import Ino25 from "../images/Ino25.jpg";
import Ino26 from "../images/Ino26.jpg";
import Ino27 from "../images/Ino27.jpg";
import Ino28 from "../images/Ino28.jpg";
import Ino29 from "../images/Ino29.jpg";
import Ino30 from "../images/Ino30.jpg";
import Ino31 from "../images/Ino31.jpeg";
import Ino32 from "../images/Ino32.jpeg";
import Ino33 from "../images/Ino33.jpeg";
import Ino34 from "../images/Ino34.jpg";
import Ino35 from "../images/Ino35.jpeg";
import Ino36 from "../images/Ino36.jpeg";
import Ino37 from "../images/Ino37.png";
import Ino38 from "../images/Ino38.jpg";
import Ino39 from "../images/Ino39.jpg";
import Ino40 from "../images/Ino40.jpg";
import Ino41 from "../images/Ino41.jpg";

// All images array
const allImages = [
  { src: Ino1 }, { src: Ino2 }, { src: Ino3 }, { src: Ino4 }, { src: Ino5 },
  { src: Ino6 }, { src: Ino7 }, { src: Ino8 }, { src: Ino9 }, { src: Ino10 },
  { src: Ino11 }, { src: Ino12 }, { src: Ino13 }, { src: Ino14 }, { src: Ino15 },
  { src: Ino16 }, { src: Ino17 }, { src: Ino18 }, { src: Ino19 }, { src: Ino20 },
  { src: Ino21 }, { src: Ino22 }, { src: Ino23 }, { src: Ino24 }, { src: Ino25 },
  { src: Ino26 }, { src: Ino27 }, { src: Ino28 }, { src: Ino29 }, { src: Ino30 },
  { src: Ino31 }, { src: Ino32 }, { src: Ino33 }, { src: Ino34 }, { src: Ino35 },
  { src: Ino36 }, { src: Ino37 }, { src: Ino38 }, { src: Ino39 }, { src: Ino40 },
  { src: Ino41 }
];

// Utility to get N random unique images
function getRandomImages(n) {
  const shuffled = [...allImages];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled.slice(0, n);
}

// Styled components
const StyledCard = styled(Card)({
  borderRadius: "16px",
  overflow: "hidden",
  transition: "transform 0.3s, box-shadow 0.3s",
  "&:hover": {
    transform: "scale(1.03)",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  },
});

const OverlayText = styled("div")({
  position: "absolute",
  bottom: 0,
  width: "100%",
  background: "rgba(0, 0, 0, 0.6)",
  color: "#fff",
  padding: "8px",
  textAlign: "center",
  fontWeight: "bold",
  fontSize: "0.9rem",
});

export default function InovaantageClicks() {
  const [images, setImages] = useState(getRandomImages(18)); // Start with 18 images

  useEffect(() => {
    const interval = setInterval(() => {
      setImages((prevImages) => {
        const newImages = [...prevImages];
        const currentSrcs = newImages.map((img) => img.src);

        // Find a new image not already in the current display
        let newImage;
        const unusedImages = allImages.filter(img => !currentSrcs.includes(img.src));
        if (unusedImages.length === 0) return newImages;

        newImage = unusedImages[Math.floor(Math.random() * unusedImages.length)];

        const replaceIndex = Math.floor(Math.random() * newImages.length);
        newImages[replaceIndex] = newImage;

        return newImages;
      });
    }, 2000); // Every 2 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    
     
      <Box sx={{ p: { xs: 2, sm: 4 }, background: "#f4f6f8" }}>
        <Typography
          variant="h4"
          gutterBottom
          textAlign="center"
          fontWeight={600}
        >
          Gallery
        </Typography>
        <Grid container spacing={3} justifyContent="center">
          {images.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.98 }}
                transition={{ duration: 0.3 }}
              >
                <StyledCard>
                  <CardActionArea>
                    <Box sx={{ position: "relative" }}>
                      <CardMedia
                        component="img"
                        height="220"
                        image={item.src}
                        alt={`Image ${index + 1}`}
                        sx={{ objectFit: "cover" }}
                      />
                      {item.caption && (
                        <OverlayText>{item.caption}</OverlayText>
                      )}
                    </Box>
                  </CardActionArea>
                </StyledCard>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Box>
      
   
  );
}